export const CURRENCY_ORDER = ['TRY', 'USD', 'EUR', 'GBP'];

export const CURRENCY_META = {
  TRY: { label: 'TRY', symbol: '₺' },
  USD: { label: 'USD', symbol: '$' },
  EUR: { label: 'EUR', symbol: '€' },
  GBP: { label: 'GBP', symbol: '£' }
};

export const normalizeCurrencyCode = (currency = 'TRY') => {
  const normalized = String(currency || 'TRY').trim().toUpperCase();
  return CURRENCY_ORDER.includes(normalized) ? normalized : 'TRY';
};

export const getCurrencyMeta = (currency = 'TRY') => (
  CURRENCY_META[normalizeCurrencyCode(currency)] || CURRENCY_META.TRY
);
